import { render } from "./FlowsList.vue?vue&type=template&id=de5ef8c4&scoped=true"
import script from "./FlowsList.vue?vue&type=script&lang=js"
export * from "./FlowsList.vue?vue&type=script&lang=js"

import "./FlowsList.vue?vue&type=style&index=0&id=de5ef8c4&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de5ef8c4"]])

export default __exports__